interface Rollbar {
  error: (message: string, error: Error) => void;
  critical: (message: string) => void;
  warning: (message: string) => void;
  info: (message: string) => void;
  debug: (message: string) => void;
  captureEvent: (
    JSON: string | any,
    level: 'error' | 'critical' | 'warning' | 'info' | 'debug'
  ) => void;
}

function rollbar(): Rollbar {
  const rollbarGlobal = (window as any).Rollbar as Rollbar;
  return (
    rollbarGlobal || {
      error: (message, error): void => {
        console.error(message);
        if (error && error.stack) {
          console.error(error.stack);
        }
      },
      critical: (message) => {
        console.error(message);
      },
      warning: (message) => {
        console.error(message);
      },
      info: (message) => {
        console.error(message);
      },
      debug: (message) => {
        console.error(message);
      },
      captureEvent: (json, level) => {
        console.log(level);
        console.error(json);
      },
    }
  );
}

function getError(): Error {
  let err;
  try {
    throw new Error();
  } catch (e) {
    err = e;
  }
  return err;
}

export default {
  error(message: string, error?: any) {
    rollbar().error(message, error || getError());
  },
  critical(message: string) {
    rollbar().critical(message);
  },
  warning(message: string) {
    rollbar().warning(message);
  },
  info(message: string) {
    rollbar().info(message);
  },
  debug(message: string) {
    rollbar().debug(message);
  },
  captureEvent(json, level: 'error' | 'critical' | 'warning' | 'info' | 'debug' = 'debug') {
    if (typeof json === 'string') {
      try {
        json = JSON.stringify(json);
      } catch (e) {
        json = '"Unkown message"';
      }
      rollbar().captureEvent(json, level);
    }
  },
};
